__turbopack_context__.v({
  "appDownloadContainer": "pb-Myq_appDownloadContainer",
  "buttonContainer": "pb-Myq_buttonContainer",
  "depopSticker": "pb-Myq_depopSticker",
  "downloadButtonContainer": "pb-Myq_downloadButtonContainer",
  "horizontalBreak": "pb-Myq_horizontalBreak",
  "horizontalBreakContainer": "pb-Myq_horizontalBreakContainer",
  "loginButton": "pb-Myq_loginButton",
  "modalBodyText": "pb-Myq_modalBodyText",
  "modalContainer": "pb-Myq_modalContainer",
  "modalTitle": "pb-Myq_modalTitle",
  "orText": "pb-Myq_orText",
  "signupButton": "pb-Myq_signupButton",
});
